import React from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useAIAnswerContext } from './ai-answer-context';
import { ReadingAidsOptions } from './reading-aids-options';
var TitleWrapperStyles = xcss({
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '52px'
});
var DefinitionTitleStyles = xcss({
  font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: 'color.text',
  marginTop: 'space.250',
  marginLeft: 'space.300'
});
export var AIAnswerTitle = function AIAnswerTitle() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    baseQuery = _useAIAnswerContext.baseQuery;
  var query = commonAttributes.query;
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: TitleWrapperStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: DefinitionTitleStyles
  }, baseQuery ? baseQuery : query), /*#__PURE__*/React.createElement(ReadingAidsOptions, null));
};